/* Feria Days — the product page
   ---------------------------------------------------------------------------
   Three jobs, all of them upgrades to markup that already works without this
   file running at all:

     1. GALLERY. The markup is a plain list of every image at full width, in
        order. That is what a phone gets if this never loads, and it is
        legible. Here the list becomes one frame with a thumbnail strip.
     2. QUANTITY. The number input is the control; the two buttons are added
        conveniences and are written by this file rather than shipped in the
        markup, so a page without script never shows a button that does
        nothing.
     3. OPTIONS. Every option value is already a link to its variant, so the
        picker works with no JavaScript. Here the click is intercepted and the
        new state is fetched and swapped in place instead of reloading.

   WHAT IS DELIBERATELY NOT SWAPPED: the add-to-cart form's buttons and
   Shopify's own payment elements. Replacing those tears out and rebuilds
   shopify-accelerated-checkout and shopify-payment-terms on every color
   click, which is how an express button ends up not rendering. The terms
   element is told the new variant through its attribute instead, which is the
   interface it publishes.

   No animation library, per the standing decision. */
(function () {
  'use strict';

  var root = document.querySelector('[data-fd-capsule]');
  if (!root) return;

  /* ---- gallery -------------------------------------------------------- */
  function gallery() {
    var gal = root.querySelector('.prod-gal');
    if (!gal) return;
    var frames = gal.querySelectorAll('.prod-frames > li');
    var thumbs = gal.querySelectorAll('.prod-thumbs button');
    if (frames.length < 2 || !thumbs.length) return;

    gal.classList.add('is-gal');
    show(0);

    Array.prototype.forEach.call(thumbs, function (b, i) {
      b.addEventListener('click', function () { show(i); });
    });

    function show(i) {
      Array.prototype.forEach.call(frames, function (f, j) {
        if (j === i) { f.setAttribute('data-on', ''); }
        else { f.removeAttribute('data-on'); }
      });
      Array.prototype.forEach.call(thumbs, function (b, j) {
        b.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }

    /* Selecting a color should show that color. Shopify gives the variant's
       own image a position in the media list; the frame carries it. */
    gal.showMedia = function (id) {
      if (!id) return;
      for (var i = 0; i < frames.length; i++) {
        if (frames[i].getAttribute('data-media') === String(id)) { show(i); return; }
      }
    };
  }

  /* ---- quantity ------------------------------------------------------- */
  function quantity() {
    var wrap = root.querySelector('.prod-qty');
    if (!wrap) return;
    var input = wrap.querySelector('input[name="quantity"]');
    if (!input) return;

    wrap.insertBefore(step('−', -1, 'One fewer'), input);
    wrap.appendChild(step('+', 1, 'One more'));

    function step(label, by, aria) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = label;
      b.setAttribute('aria-label', aria);
      b.addEventListener('click', function () {
        var n = parseInt(input.value, 10);
        if (isNaN(n)) n = 1;
        n = Math.max(1, n + by);
        input.value = n;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      return b;
    }
  }

  /* ---- options -------------------------------------------------------- */
  function options() {
    if (!window.fetch || !window.history || !window.DOMParser) return;

    root.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.prod-chips a[data-fd-variant]') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      swap(a.getAttribute('href'), a.getAttribute('data-fd-variant'));
    });

    function swap(url, id) {
      /* There is more than one live region — the price sits above Shopify's
         installment widget and the pickers below it, and that widget must not
         be torn out. They are matched by position, which is stable because
         both documents are this same section. */
      var live = root.querySelectorAll('[data-fd-live]');
      if (!live.length) { window.location.assign(url); return; }
      live[0].setAttribute('aria-busy', 'true');

      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelectorAll('[data-fd-live]');
          if (next.length !== live.length) throw new Error('live regions differ');

          for (var i = 0; i < live.length; i++) live[i].innerHTML = next[i].innerHTML;
          live[0].removeAttribute('aria-busy');

          /* the id the form posts */
          var input = root.querySelector('input[name="id"]');
          if (input) input.value = id;

          /* availability, read from the freshly rendered button rather than
             worked out here twice */
          var here = root.querySelector('[data-fd-atc]');
          var there = doc.querySelector('[data-fd-atc]');
          if (here && there) {
            here.textContent = there.textContent;
            if (there.hasAttribute('disabled')) here.setAttribute('disabled', '');
            else here.removeAttribute('disabled');
          }

          /* Shopify's installment widget, told rather than rebuilt */
          var terms = root.querySelector('shopify-payment-terms');
          if (terms) terms.setAttribute('variant-id', id);

          var gal = root.querySelector('.prod-gal');
          if (gal && gal.showMedia) gal.showMedia(next[0].getAttribute('data-fd-media'));

          window.history.replaceState({}, '', url);
        })
        .catch(function () {
          /* the link was always the real control; fall back to it */
          window.location.assign(url);
        });
    }
  }

  /* ---- the makers' quotes --------------------------------------------- */
  function quotes() {
    var wrap = root.querySelector('[data-fd-quotes]');
    if (!wrap) return;
    var items = wrap.querySelectorAll('[data-fd-quote]');
    if (items.length < 2) return;

    wrap.classList.add('is-pager');
    var at = 0;
    show(0);

    var arws = document.createElement('div');
    arws.className = 'prod-arws';
    arws.appendChild(arrow('\u2039', -1, 'Previous quote'));
    arws.appendChild(arrow('\u203A', 1, 'Next quote'));
    /* Inside the wrapper, not after it: the arrows are a grid cell beside the
       quote, which is what puts them at the end of the row the way the
       approved mockup has them. */
    wrap.appendChild(arws);

    function arrow(label, by, aria) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = label;
      b.setAttribute('aria-label', aria);
      b.addEventListener('click', function () {
        at = (at + by + items.length) % items.length;
        show(at);
      });
      return b;
    }

    function show(i) {
      Array.prototype.forEach.call(items, function (el, j) {
        if (j === i) { el.setAttribute('data-on', ''); }
        else { el.removeAttribute('data-on'); }
      });
    }
  }

  /* ---- the share offer ------------------------------------------------ */
  /* TWO STAGES. The button opens the modal; stage one is where to post it,
     one or more; stage two is the code and the two things it is for.

     HONOR SYSTEM, AND THE CODE SAYS SO. Each platform link opens that
     platform's own composer in a new window and reports nothing back — no
     callback, no post URL, no confirmation. Choosing a destination is what
     unlocks the code, and nothing here pretends to have checked more than
     that. It is a step weaker than the native share sheet, which at least
     rejects when dismissed; that is the price of letting someone choose, and
     of working on a desktop where no sheet exists.

     Both states are in the markup. The button ships hidden, so a browser with
     no script shows the code rather than a button that cannot open anything. */
  function share() {
    var block = root.querySelector('[data-fd-share]');
    if (!block) return;
    var go = block.querySelector('[data-fd-share-go]');
    var got = block.querySelector('[data-fd-share-got]');
    var modal = block.querySelector('[data-fd-share-modal]');
    if (!go || !got || !modal || !modal.showModal) return;

    var code = block.getAttribute('data-code');
    var url = block.getAttribute('data-url');
    var key = 'fd-shared-' + code;

    var s1 = modal.querySelector('[data-fd-stage="1"]');
    var s2 = modal.querySelector('[data-fd-stage="2"]');
    var claim = modal.querySelector('[data-fd-share-claim]');
    var note = modal.querySelector('[data-fd-share-note]');
    var nets = modal.querySelectorAll('[data-fd-net]');

    /* Someone who already shared skips straight to the code on a later visit.
       Per-browser and best-effort: a private window loses it, which costs one
       more pass through stage one and nothing else. */
    var already = false;
    try { already = window.localStorage.getItem(key) === '1'; } catch (e) {}

    go.hidden = false;
    got.hidden = true;
    go.addEventListener('click', function () { openAt(already ? 2 : 1); });

    var closeBtn = modal.querySelector('[data-fd-share-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
    modal.addEventListener('click', function (e) {
      /* The dialog element is its own backdrop, so a click landing on it
         rather than on the inner panel is a click outside. */
      if (e.target === modal) modal.close();
    });

    /* The native sheet is offered as one more destination where it exists,
       so a phone keeps the route its owner expects. */
    var nativeLi = modal.querySelector('[data-fd-net-native]');
    if (nativeLi && navigator.share) nativeLi.hidden = false;

    Array.prototype.forEach.call(nets, function (el) {
      el.addEventListener('click', function (e) {
        var which = el.getAttribute('data-fd-net');

        if (which === 'copy') {
          e.preventDefault();
          copyText(url, el);
          if (note) note.hidden = false;
        } else if (which === 'native') {
          e.preventDefault();
          navigator.share({
            title: block.getAttribute('data-title'),
            text: block.getAttribute('data-text'),
            url: url
          }).catch(function () {});
        }
        /* Everything else is a real link with target=_blank and is left to
           open on its own. */

        el.setAttribute('data-done', '');
        if (claim) claim.removeAttribute('disabled');
      });
    });

    if (claim) {
      claim.addEventListener('click', function () {
        try { window.localStorage.setItem(key, '1'); } catch (e) {}
        already = true;
        stage(2);
      });
    }

    var copy = modal.querySelector('[data-fd-share-copy]');
    if (copy) copy.addEventListener('click', function () { copyText(code, copy); });

    var add = modal.querySelector('[data-fd-share-add]');
    if (add) {
      add.addEventListener('click', function () {
        var idInput = root.querySelector('input[name="id"]');
        var qtyInput = root.querySelector('input[name="quantity"]');
        /* Shopify's own route: it applies the code to the session and then
           redirects, so the code is never typed. The add goes first, so the
           cart it lands on already has the item in it. */
        var onward = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';

        if (!idInput || !window.fetch) { window.location.assign(onward); return; }

        add.setAttribute('disabled', '');
        add.textContent = 'Adding\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: idInput.value,
            quantity: parseInt(qtyInput && qtyInput.value, 10) || 1
          })
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          window.location.assign(onward);
        }).catch(function () {
          /* Sold out, or the variant moved while the panel was open. Go to the
             discount anyway rather than stranding them on a dead button; the
             cart will show the truth. */
          window.location.assign(onward);
        });
      });
    }

    function stage(n) {
      if (s1) s1.hidden = n !== 1;
      if (s2) s2.hidden = n !== 2;
    }

    function openAt(n) {
      stage(n);
      try { modal.showModal(); } catch (e) {}
    }

    /* Where the clipboard is refused — an insecure context, or permission
       denied — the text is selected instead, so copying is one keystroke
       rather than a transcription. */
    function copyText(text, button) {
      var said = button && button.querySelector('.prod-net-label');
      var target = said || button;
      var was = target ? target.textContent : '';
      var done = function () {
        if (!target) return;
        target.textContent = 'Copied';
        setTimeout(function () { target.textContent = was; }, 2400);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(function () { pick(text); });
      } else {
        pick(text);
      }
    }

    function pick(text) {
      var el = modal.querySelector('[data-fd-share-code]');
      if (!el || el.textContent.trim() !== text || !window.getSelection || !document.createRange) return;
      var r = document.createRange();
      r.selectNodeContents(el);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(r);
    }
  }


  /* ---- the add-to-cart panel and its bundle upgrade ---------------------
     Oct 6, Nathan. Add to cart posts through fetch, then the panel opens on
     what was added and, read from the cart as it now stands, offers the
     shirts that would complete The Triduum or The Pair. The bundle prices
     are Shopify automatic discounts; nothing here prices anything, it only
     adds ordinary shirts and says which saving applies.

     Buy now is left alone: it carries return_to=/checkout and must go
     straight there. With no script, or if anything here fails, the form
     posts normally and lands on the cart, which is the page's original
     behavior. */
  function upsell() {
    var form = document.getElementById('fd-buy');
    var dlg = root.querySelector('[data-fd-up]');
    var dataEl = root.querySelector('[data-fd-up-catalog]');
    if (!form || !dlg || !dataEl || !window.fetch || !dlg.showModal) return;

    var cat = [];
    try { cat = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var byHandle = {};
    cat.forEach(function (p) { byHandle[p.handle] = p; });

    var D = dlg.dataset;
    var addedEl = dlg.querySelector('[data-fd-up-added]');
    var offerEl = dlg.querySelector('[data-fd-up-offer]');
    var errEl = dlg.querySelector('[data-fd-up-err]');
    var atc = form.querySelector('[data-fd-atc]');
    var money = function (c) {
      var d = c / 100;
      return '$' + (d % 1 ? d.toFixed(2) : String(d));
    };
    var fill = function (t, o) {
      return t.replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; });
    };
    var esc = function (t) {
      return String(t).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };

    var close = dlg.querySelector('[data-fd-up-close]');
    if (close) close.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });

    form.addEventListener('submit', function (e) {
      var by = e.submitter;
      if (!by || !by.hasAttribute('data-fd-atc')) return;   // Buy now, or unknown: post as normal
      e.preventDefault();
      atc.disabled = true;
      atc.classList.add('is-sending');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return r.json();
      }).then(function (item) {
        return cart().then(function (c) { open(item, c); });
      }).catch(function () {
        form.submit();                                        // fall back to the plain post
      }).then(function () {
        atc.disabled = false;
        atc.classList.remove('is-sending');
      });
    });

    function cart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { badge(c.item_count); return c; });
    }

    function badge(n) {
      var link = document.querySelector('.sitecart');
      if (!link) return;
      var num = link.querySelector('.sitecart-n');
      var vh = link.querySelector('.vh');
      if (!num) {
        num = document.createElement('span'); num.className = 'sitecart-n';
        num.setAttribute('aria-hidden', 'true'); link.appendChild(num);
      }
      if (!vh) { vh = document.createElement('span'); vh.className = 'vh'; link.appendChild(vh); }
      num.textContent = n;
      vh.textContent = n + ' item' + (n === 1 ? '' : 's');
    }

    function tally(c) {
      var t = { tee: 0, sweat: 0, teeDesigns: {} };
      c.items.forEach(function (it) {
        var p = byHandle[it.handle];
        if (!p) return;
        t[p.kind] += it.quantity;
        if (p.kind === 'tee') t.teeDesigns[p.design] = true;
      });
      return t;
    }

    function open(item, c) {
      errEl.hidden = true;
      var detail = (item.variant_title ? item.variant_title.replace(/ \/ /g, ' · ') + ' · ' : '') +
        'Qty ' + item.quantity;
      addedEl.innerHTML =
        '<div class="fd-up-added">' +
        (item.image ? '<img src="' + esc(item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt="" width="72" height="72">' : '<span></span>') +
        '<div><p class="fd-up-name">' + esc(item.product_title) + '</p><p class="note">' + esc(detail) + '</p></div>' +
        '<p class="fd-up-price">' + money(item.final_line_price) + '</p></div>';
      var size = '';
      (item.options_with_values || []).forEach(function (o) {
        if (String(o.name).toLowerCase() === 'size') size = o.value;
      });
      var added = byHandle[item.handle];
      render(added, tally(c), size, c);
      try { dlg.showModal(); } catch (e) {}
    }

    /* WHAT ACTUALLY APPLIES, read from the cart Shopify returns rather than
       inferred from counts. Found Oct 7 on the live store: The Triduum and The
       Pair do not stack — three t-shirts and a sweatshirt get the Triduum's $18
       and not the Pair's $15, because the Pair's qualifying t-shirt is already
       discounted. So the panel reports Shopify's allocations, never a rule. */
    function applied(c) {
      var by = {}, order = [];
      c.items.forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (a) {
          var k = a.discount_application && a.discount_application.title;
          if (!k || !a.amount) return;
          if (!(k in by)) { by[k] = 0; order.push(k); }
          by[k] += a.amount;
        });
      });
      return order.map(function (k) { return fill(D.applied, { title: k, off: money(by[k]) }); }).join(' ');
    }

    function render(added, t, size, c) {
      offerEl.innerHTML = '';
      if (!added) return;
      var tees = cat.filter(function (p) { return p.kind === 'tee'; });
      var teePrice = tees.length ? tees[0].price : 0;
      var tOff = +D.triduumOff, pOff = +D.pairOff;

      if (added.kind === 'tee') {
        if (t.tee >= 3) return done(applied(c) || fill(D.tDone, { off: money(tOff) }));
        var need = 3 - t.tee;
        var picks = tees.filter(function (p) { return !t.teeDesigns[p.design]; }).slice(0, need);
        if (picks.length < need) return;
        var full = teePrice * 3;
        var v = { total: money(full - tOff), full: money(full) };
        var body = picks.length === 2 ? D.tBodyTwo : fill(D.tBodyOne, { design: picks[0].label });
        var btn = picks.length === 2 ? D.tBtnTwo : D.tBtnOne;
        offer(D.tEyebrow, D.tHead, fill(body, v), fill(btn, v),
              picks.length === 2 ? D.pickMany : D.pickOne,
              picks.map(function (p) { return { choices: [p], p: p }; }), size);
      } else if (added.kind === 'sweat') {
        if (t.tee >= 1) { var said = applied(c); if (said) done(said); return; }
        if (!tees.length) return;
        var start = tees.filter(function (p) { return p.design === added.design; })[0] || tees[0];
        var full2 = teePrice + added.price;
        var v2 = { total: money(full2 - pOff), full: money(full2) };
        offer(D.pEyebrow, D.pHead, fill(D.pBody, v2), fill(D.pBtn, v2), D.pickOne,
              [{ choices: tees, p: start }], size);
      }
    }

    function done(text) {
      offerEl.innerHTML = '<p class="fd-up-done">' + esc(text) + '</p>';
    }

    /* slots: one per shirt to add. Each slot holds the product it currently
       shows, the products it may switch between (the Pair's design choice),
       and the chosen color and size. */
    function offer(eyebrow, head, body, label, waiting, slots, size) {
      var sec = document.createElement('section');
      sec.className = 'fd-up-offer';
      sec.setAttribute('aria-labelledby', 'fd-up-oh');
      sec.innerHTML =
        '<p class="micro fd-up-eyebrow">' + esc(eyebrow) + '</p>' +
        '<h3 id="fd-up-oh">' + esc(head) + '</h3>' +
        '<p class="fd-up-body">' + esc(body) + '</p>' +
        '<div class="fd-up-cards"></div>';
      var cards = sec.querySelector('.fd-up-cards');
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'btn btn--gold fd-up-add';
      sec.appendChild(add);
      offerEl.appendChild(sec);

      slots.forEach(function (s) {
        s.color = null;
        s.size = s.p.sizes.indexOf(size) > -1 ? size : null;
        s.el = document.createElement('div');
        s.el.className = 'fd-up-card';
        cards.appendChild(s.el);
        draw(s);
      });
      sync();

      function draw(s) {
        var p = s.p;
        var v = variant(s);
        var img = (v && v.img) || p.img;
        var html = '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="400" height="400" loading="lazy">' +
          '<div class="fd-up-card-in">';
        if (s.choices.length > 1) {
          html += group('Design', s.choices.map(function (c) { return c.num + ' · ' + c.label; }),
                        p.num + ' · ' + p.label, 'design');
        }
        html += '<p class="fd-up-name"><span class="micro">' + esc(p.num) + '</span> ' + esc(p.title) + '</p>' +
          '<p class="fd-up-price">' + money(p.price) + '</p>' +
          group('Color', p.colors, s.color, 'color', s) +
          group('Size', p.sizes, s.size, 'size', s) + '</div>';
        s.el.innerHTML = html;
        Array.prototype.forEach.call(s.el.querySelectorAll('[data-k]'), function (b) {
          b.addEventListener('click', function () {
            if (b.getAttribute('aria-disabled') === 'true') return;
            var k = b.getAttribute('data-k'), val = b.getAttribute('data-v');
            if (k === 'design') {
              s.p = s.choices.filter(function (c) { return c.num + ' · ' + c.label === val; })[0] || s.p;
              if (s.p.colors.indexOf(s.color) < 0) s.color = null;
              if (s.p.sizes.indexOf(s.size) < 0) s.size = null;
            } else {
              s[k] = val;
            }
            draw(s); sync();
            var again = s.el.querySelector('[data-k="' + k + '"][data-v="' + CSS.escape(val) + '"]');
            if (again) again.focus();
          });
        });
      }

      /* A value is struck through, the way the product page does it, when
         the other choice already made leaves no variant in stock with it. */
      function group(name, values, chosen, key, s) {
        return '<div class="fd-up-opt"><span class="micro">' + esc(name) + '</span>' +
          '<ul class="prod-chips fd-up-chips" role="radiogroup" aria-label="' + esc(name) + '">' +
          values.map(function (v) {
            var out = false;
            if (s && (key === 'color' || key === 'size')) {
              var c = key === 'color' ? v : s.color, z = key === 'size' ? v : s.size;
              out = s.p.variants.every(function (x) {
                return !x.a || (c && x.o[s.p.ci] !== c) || (z && x.o[s.p.si] !== z);
              });
            }
            return '<li><button type="button" role="radio" data-k="' + key + '" data-v="' + esc(v) +
              '" aria-checked="' + (v === chosen) + '"' +
              (out ? ' class="is-out" aria-disabled="true"' : '') + '>' + esc(v) +
              (out ? '<span class="vh">, unavailable</span>' : '') + '</button></li>';
          }).join('') + '</ul></div>';
      }

      function variant(s) {
        if (!s.color || !s.size) return null;
        return s.p.variants.filter(function (v) {
          return v.o[s.p.ci] === s.color && v.o[s.p.si] === s.size;
        })[0] || null;
      }

      function sync() {
        var ready = slots.every(function (s) { var v = variant(s); return v && v.a; });
        add.disabled = !ready;
        add.textContent = ready ? label : waiting;
      }

      add.addEventListener('click', function () {
        var items = slots.map(function (s) { return { id: variant(s).id, quantity: 1 }; });
        add.disabled = true;
        add.classList.add('is-sending');
        errEl.hidden = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add ' + r.status);
          return cart();
        }).then(function (c) {
          var t = tally(c);
          var tOff = +D.triduumOff, pOff = +D.pairOff;
          done(applied(c) || (t.tee >= 3 ? fill(D.tDone, { off: money(tOff) }) : fill(D.pDone, { off: money(pOff) })));
        }).catch(function () {
          add.classList.remove('is-sending');
          sync();
          errEl.textContent = D.fail;
          errEl.hidden = false;
        });
      });
    }
  }

  gallery();
  quantity();
  options();
  quotes();
  share();
  upsell();
})();
